<template>
  <bananer />
  <div class="navContainer">
    <Nav />
  </div>
  <router-view></router-view>
  <AppFooter />
  <div class="sideBar">
    <SideFload />
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue';
import bananer from './components/bananer.vue';
import Nav from './views/Nav.vue';
import AppFooter from './components/AppFooter.vue';
import SideFload from "./components/SideFload.vue"
export default {
  name: 'App',
  components: {
    HelloWorld,
    bananer,
    Nav,
    AppFooter,
    SideFload

  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  margin-top: 0px;
}

body {
  display: block;
  margin: 0px;
  background-color: #EFEFEF;
}

.navContainer {
  position: sticky;
  top: 0;
}
.sideBar {
  position: fixed;
  right: 20px;
  top: 300px;
  z-index: 2000;
}
</style>